import { useCallback, useEffect, useState } from 'react'

import { Grid } from 'antd'

const { useBreakpoint: GridUseBreakpoint } = Grid

const useBreakPoint = () => {
  const screens = GridUseBreakpoint()
  const [{ xs, sm, md, lg }, setState] = useState({
    xs: false,
    sm: false,
    md: false,
    lg: false,
  })

  const updateState = useCallback((newObj) => {
    setState((preData) => {
      return { ...preData, ...newObj }
    })
  }, [])

  useEffect(() => {
    const tempValue = { xs: false, sm: false, md: false, lg: false }
    if (screens?.sm && screens?.md && screens?.lg) {
      tempValue.lg = true
    } else if (screens?.sm && screens?.md) {
      tempValue.md = true
    } else if (screens?.sm) {
      tempValue.sm = true
    } else if (screens?.xs) {
      tempValue.xs = true
    }
    updateState(tempValue)
  }, [screens?.lg, screens?.md, screens?.sm, screens?.xs, updateState])

  return { xs, sm, md, lg }
}

export default useBreakPoint
